<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import ChartUsersAge from "@/components/widgets/ChartUsersAge";
import ChartUsersConnections from "@/components/widgets/ChartUsersConnections";
import ChartUsersConnectionsGenders from "@/components/widgets/ChartUsersConnectionsGenders";
import ChartMessagesGenders from "@/components/widgets/ChartMessagesGenders";
import ChartUsersConnectionsCountry from "@/components/widgets/ChartUsersConnectionsCountry";
import ChartMessagesCountry from "@/components/widgets/ChartMessagesCountry";
import ChartChatRoomsCountry from "@/components/widgets/ChartChatRoomsCountry";
import ChartUsersConnectionsAdSource from "@/components/widgets/ChartUsersConnectionsAdSource";
import ChartUsersConnectionsAppVersion from "@/components/widgets/ChartUsersConnectionsAppVersion";
import ChartUsersTokens from "@/components/widgets/ChartUsersTokens";
import ChartUsersGender from "@/components/widgets/ChartUsersGender";
import ChartUsersVideos from "@/components/widgets/ChartUsersVideos";
import ChartUsersRegister from "@/components/widgets/ChartUsersRegister";
import ChartUsersCountries from "@/components/widgets/ChartUsersCountries";
import ChartUsersEmail from "@/components/widgets/ChartUsersEmail";
import StatsDataService from "@/services/StatsDataService";
import {authComputed} from "@/state/helpers";

export default {
  name: "users",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Dashboard Users",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ChartUsersAge,
    ChartUsersConnections,
    ChartUsersConnectionsGenders,
    ChartMessagesGenders,
    ChartUsersConnectionsCountry,
    ChartMessagesCountry,
    ChartChatRoomsCountry,
    ChartUsersConnectionsAdSource,
    ChartUsersConnectionsAppVersion,
    ChartUsersGender,
    ChartUsersRegister,
    ChartUsersCountries,
    ChartUsersEmail,
    ChartUsersVideos,
    ChartUsersTokens
  },
  methods: {
    getInitials (fullName) {
      return fullName.split(' ').map(name => name[0]).join('').toUpperCase();
    },

    loadData() {
      let params = {};
      params.today = new this.$moment().format('YYYY-MM-DD');
      StatsDataService.getUsersGenderTodayStats(params)
        .then(response => {
          this.todayMale = response.data.results.male;
          this.todayFemale = response.data.results.female;
          this.media.pictures.invalid = response.data.media.pictures.invalid;
          this.media.pictures.total = response.data.media.pictures.total;
          this.media.pictures.avg = response.data.media.pictures.avg;
          this.media.videos.invalid = response.data.media.videos.invalid;
          this.media.videos.total = response.data.media.videos.total;
          this.media.videos.avg = response.data.media.videos.avg;
          this.others.usersDisabled = response.data.others.usersDisabled;
          this.others.blockedPhones = response.data.others.blockedPhones;
        })
        .catch(error => {
          window.console.error("StatsDataService.getUsersGenderTodayStats failed...", error);
        });
    }
  },

  computed: {
    ...authComputed
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      title: this.$t("menuitems.dashboards.users"),
      todayMale: '-',
      todayFemale: '-',
      others: {
        usersDisabled: '-',
        blockedPhones: '-',
        blockedIPs: '-',
      },
      media: {
        pictures: {
          invalid: '-',
          total: '-',
          avg: '-'
        },
        videos: {
          invalid: '-',
          total: '-',
          avg: '-'
        }
      },
      filtersDates: {
        dateRange: null,
        selected: 'curYear',
        fromDate: null,
        toDate: null,
        options: [
          {value:'today', text:this.$t("dates.today")},
          {value:'yesterday', text:this.$t("dates.yesterday")},
          {value:'curMonth', text:this.$t("dates.curMonth")},
          {value:'lastMonth', text:this.$t("dates.lastMonth")},
          {value:'last3Month', text:this.$t("dates.last3Month")},
          {value:'curYear', text:this.$t("dates.curYear")},
          {value:'always', text:this.$t("dates.always")},
          {value:'custom', text:this.$t("dates.custom")}
        ]
      }
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <!-- Today Male -->
          <div class="col-lg-3">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-3">
                    <p class="text-muted mb-2">Today Male</p>
                    <h5 class="mb-0">{{ todayMale }}</h5>
                  </div>

                  <div class="avatar-sm ms-auto">
                    <div
                        class="avatar-title bg-info rounded-circle white font-size-20"
                    >
                      <i class="bx bxs-user"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Today Female -->
          <div class="col-lg-3">
            <div class="card blog-stats-wid ">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-3">
                    <p class="text-muted mb-2">Today Female</p>
                    <h5 class="mb-0">{{ todayFemale }}</h5>
                  </div>

                  <div class="avatar-sm ms-auto">
                    <div
                        class="avatar-title bg-pink text-white rounded-circle font-size-20"
                    >
                      <i class="bx bxs-user"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Media Pictures -->
          <div class="col-lg-3">
            <div class="card blog-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-3">
                    <p class="text-muted mb-2">Media Pictures</p>
                    <h5 class="mb-0">{{ media.pictures.total }} <small>/ <span class="text-warning">{{ media.pictures.invalid }} invalid </span> / <span class="info">{{ media.pictures.avg }} per user</span></small></h5>
                  </div>

                  <div class="avatar-sm ms-auto">
                    <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                    >
                      <i class="bx bxs-image"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Media Videos -->
          <div class="col-lg-3">
            <div class="card blog-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-3">
                    <p class="text-muted mb-2">Media Videos</p>
                    <h5 class="mb-0">{{ media.videos.total }} <small>/ <span class="text-warning">{{ media.videos.invalid }} invalid </span> / <span class="info">{{ media.videos.avg }} per user</span></small></h5>
                  </div>

                  <div class="avatar-sm ms-auto">
                    <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                    >
                      <i class="bx bxs-image"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <!-- Disabled Users -->
      <div class="col-lg-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Disabled Users</p>
                <h5 class="mb-0">{{ others.usersDisabled }}</h5>
              </div>
              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-info rounded-circle white font-size-20"
                >
                  <i class="bx bxs-user"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Blocked Phones -->
      <div class="col-lg-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Blocked Phones</p>
                <h5 class="mb-0">{{ others.blockedPhones }}</h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-info rounded-circle white font-size-20"
                >
                  <i class="bx bxs-user"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <!-- Admin Profile -->
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="me-3">
                <img
                    v-if="getUser.photoURL"
                    :src="getUser.photoURL"
                    alt=""
                    class="avatar-sm rounded-circle img-thumbnail"
                />
                <span class="avatar-sm rounded-circle img-thumbnail bg-success text-white font-size-14 d-inline-block text-center" style="line-height: 2.5rem;" >{{ getInitials(getUser.displayName) }}</span>
              </div>
              <div class="media-body">
                <div class="media">
                  <div class="media-body">
                    <div class="text-muted">
                      <h5 class="mb-1">{{ getUser.displayName }}</h5>
                      <p class="mb-0">{{ getUser.email }}</p>
                    </div>
                  </div>

                  <b-dropdown
                      toggle-class="btn-sm"
                      variant="light"
                      right
                      class="ms-2"
                      menu-class="dropdown-menu-end"
                  >
                    <template #button-content>
                      <i class="bx bxs-cog align-middle me-1"></i> Settings
                    </template>
                    <b-dropdown-item>
                      <router-link tag="span" to="/admin/profile">
                        <i class="bx bx-user font-size-16 align-middle me-1"></i>
                        {{ $t("edit") }}
                      </router-link>
                    </b-dropdown-item>
                    <a href="/logout" class="dropdown-item text-danger">
                      <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
                      ></i> {{ $t("logout") }}
                    </a>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Users Gender -->
      <div class="col-12 col-lg-4">
        <div class="card">
          <ChartUsersGender></ChartUsersGender>
        </div>
      </div>
      <!-- Users Countries -->
      <div class="col-12 col-lg-4">
        <div class="card">
          <ChartUsersCountries></ChartUsersCountries>
        </div>
      </div>
      <!-- Users Email -->
      <div class="col-12 col-lg-4">
        <div class="card">
          <ChartUsersEmail></ChartUsersEmail>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Users Videos -->
      <div class="col-12 col-lg-4">
        <div class="card">
          <ChartUsersVideos></ChartUsersVideos>
        </div>
      </div>

      <!-- User Register -->
      <div class="col-12 col-lg-8">
        <div class="card">
          <ChartUsersRegister></ChartUsersRegister>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- users tokens -->
      <div class="col-12">
        <div class="card">
          <ChartUsersTokens></ChartUsersTokens>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- User Age -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartUsersAge></ChartUsersAge>
        </div>
      </div>

      <!-- User Connections -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartUsersConnections></ChartUsersConnections>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- User Connections Gender -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartUsersConnectionsGenders></ChartUsersConnectionsGenders>
        </div>
      </div>

      <!-- User Connections Country -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartUsersConnectionsCountry></ChartUsersConnectionsCountry>
        </div>
      </div>

    </div>

    <div class="row">
      <!-- User Connections Ad Source -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartUsersConnectionsAdSource></ChartUsersConnectionsAdSource>
        </div>
      </div>

      <!-- User Connections App Version -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartUsersConnectionsAppVersion></ChartUsersConnectionsAppVersion>
        </div>
      </div>

    </div>

    <div class="row">
      <!-- Messages Gender -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartMessagesGenders></ChartMessagesGenders>
        </div>
      </div>

      <!-- Messages Country -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartMessagesCountry></ChartMessagesCountry>
        </div>
      </div>

    </div>

    <div class="row">
      <!-- ChatRooms Country -->
      <div class="col-12 col-lg-6">
        <div class="card">
          <ChartChatRoomsCountry></ChartChatRoomsCountry>
        </div>
      </div>


    </div>

  </Layout>
</template>

<style scoped>
.bg-pink {
  background-color: #f06292;
}
</style>
